import { createStyles, Theme } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    title: {
      fontSize: '18px',
      marginTop: '40px',
      color: theme.palette.primary.main,
    },
    accountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      height: 60,
      marginTop: 25,
    },
    textField: {
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    icon: {
      position: 'absolute',
      bottom: '10px',
      right: '75px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    titleLine: {
      width: 460,
      height: 2,
      marginTop: 18,
      backgroundColor: theme.palette.primary.main,
    },
    formContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.secondary.main,
    },
    enterpriseTip: {
      marginTop: 18,
      width: 460,
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: 14,
      color: '#999'
    },
    slider: {
      '@global': {
        '.geetest_holder': {
          width: '460px !important',
        },
      }
    },
    loginButtonWrapper: {
      width: '460px',
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '25px',
      borderRadius: '4px',
      background: '#FA534A',
      color: '#fff',
      cursor: 'pointer',
    },
    btnDisabled: {
      opacity: '0.5',
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
  })
